import StatesAccordions from './../components/participating_states/StatesAccordions.vue'
import { createApp } from 'vue';
import StatesMap from './../components/participating_states/StatesMap.vue';

if ( document.getElementById('states_map') ) {
    const app = createApp({
        components: {
            StatesMap
        }
    });
    app.mount('#states_map');
}

if ( document.getElementById('states_accordions') ) {
    const app2 = createApp({
        components: {
            StatesAccordions
        }
    });
    app2.mount('#states_accordions');
}